import {
    AccountIcon,
    AddressCardIcon,
    CalendarIcon,
    CheckboxIcon,
    ChevronDownIcon,
    ContactIcon,
    EmailIcon,
    FileUploadIcon,
    LongTextIcon,
    NoteIcon,
    PhoneIcon,
    RadioIcon,
    ShortTextIcon,
} from 'shells/icon';
import {FileImageIcon} from 'shells/icon/svg/file-image-icon';
import {H1Icon} from 'shells/icon/svg/h1-icon';
import {H2Icon} from 'shells/icon/svg/h2-icon';
import {TextBlockIcon} from 'shells/icon/svg/text-block-icon';

import type {FieldDef} from './types';

export const FORM_FIELD_DRAG_TYPE = 'FORM_FIELD' as const;

export const CONTENT_BLOCKS: FieldDef[] = [
    // Header blocks
    {icon: H1Icon, label: 'Header', dragData: {kind: 'header', fieldType: 'HEADER'}},
    {icon: H2Icon, label: 'Subheader', dragData: {kind: 'header', fieldType: 'SUBHEADER'}},
    {icon: TextBlockIcon, label: 'Text block', dragData: {kind: 'header', fieldType: 'TEXT'}},
    {icon: FileImageIcon, label: 'Image', dragData: {kind: 'header', fieldType: 'IMAGE'}},
    // Input fields
    {icon: ShortTextIcon, label: 'Short text', dragData: {kind: 'custom', view: 'short-text'}},
    {icon: LongTextIcon, label: 'Long text', dragData: {kind: 'custom', view: 'long-text'}},
    {
        icon: ContactIcon,
        label: 'Name',
        dragData: {
            kind: 'input',
            input: {fieldKey: 'name', displayType: 'textfield', entityType: 'Contacts'},
        },
    },
    {
        icon: AccountIcon,
        label: 'Company',
        dragData: {
            kind: 'input',
            input: {fieldKey: 'name', displayType: 'textfield', entityType: 'Accounts'},
        },
    },
    {
        icon: EmailIcon,
        label: 'Email',
        dragData: {
            kind: 'input',
            input: {fieldKey: 'email', displayType: 'textfield', entityType: 'Contacts'},
        },
    },
    {
        icon: PhoneIcon,
        label: 'Phone',
        dragData: {
            kind: 'input',
            input: {fieldKey: 'phone', displayType: 'textfield', entityType: 'Contacts'},
        },
    },
    {
        icon: AddressCardIcon,
        label: 'Address',
        dragData: {
            kind: 'input',
            input: {fieldKey: 'address', displayType: 'singleLineAddress', entityType: 'Contacts'},
        },
    },
    {
        icon: NoteIcon,
        label: 'Note',
        dragData: {
            kind: 'input',
            input: {fieldKey: 'note', displayType: 'textarea', entityType: 'Contacts'},
        },
    },
    {
        icon: FileUploadIcon,
        label: 'File upload',
        dragData: {
            kind: 'input',
            input: {fieldKey: 'file', displayType: 'file', entityType: 'Contacts'},
        },
    },
    {icon: ChevronDownIcon, label: 'Dropdown', dragData: {kind: 'custom', view: 'dropdown'}},
    {icon: RadioIcon, label: 'Radio', dragData: {kind: 'custom', view: 'radio'}},
    {icon: CheckboxIcon, label: 'Checkbox', dragData: {kind: 'custom', view: 'checkbox'}},
    {icon: CalendarIcon, label: 'Date', dragData: {kind: 'custom', view: 'date'}},
];
